import React, { useEffect, useState } from "react";
import { useParams, Link, useLocation, useNavigate } from "react-router-dom";
import "../styles/public.css";
import axios from "../axios";
import { saveGuestScan } from "../utils/guestStorage";
import { QRCodeCanvas } from "qrcode.react";

const PublicProductPage = () => {
  const { productId } = useParams();
  const [product, setProduct] = useState(null);
  const [error, setError] = useState(null);
  const [ready, setReady] = useState(false);
  const [showBanner, setShowBanner] = useState(false); // 🔥 bannière “nouveaux produits”

  const location = useLocation();
  const navigate = useNavigate();

  const getQRUrl = (id) =>
    `${window.location.origin}/product/${id}?fromQR=true`;

  // 🔔 Petit effet “bannière fun” après 2 minutes sur cette page
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowBanner(true);
      setTimeout(() => setShowBanner(false), 5000);
    }, 120000); // 2 minutes

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await axios.get(`/products/${productId}`);
        setProduct(response.data);

        const queryParams = new URLSearchParams(location.search);
        const fromQR = queryParams.get("fromQR");

        const storedUser = localStorage.getItem("user");
        const user = storedUser ? JSON.parse(storedUser) : null;

        // ➤ Scan invité via QR code
        if (!user && fromQR && response.data?._id) {
          const scanData = {
            id: response.data._id,
            productId: response.data.productId,
            name: response.data.articleName,
          };
          saveGuestScan(scanData);
          return navigate("/login");
        }

        // ➤ Historique invité local
        if (!user) {
          const raw = localStorage.getItem("pendingScans");
          const existing = raw ? JSON.parse(raw) : [];
          const id = response.data._id || response.data.productId;
          const already = existing.some((p) => p.id === id);

          if (!already) {
            const updated = [...existing, { id, name: response.data.articleName }];
            localStorage.setItem("pendingScans", JSON.stringify(updated));
          }
        }

        setTimeout(() => setReady(true), 200);
      } catch (err) {
        console.error("Erreur produit invité :", err);
        setError("Produit introuvable ou erreur serveur.");
      }
    };

    fetchProduct();
  }, [productId, location.search, navigate]);

  if (error) {
    return <div className="p-6 text-red-600">{error}</div>;
  }

  if (!product) {
    return <div className="p-6 text-gray-600">Chargement...</div>;
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-white">
      {/* 🔥 Bannière animée “nouveaux produits” */}
      {showBanner && (
        <div className="cn-banner-top">
          🔥 De nouveaux produits sont disponibles à tester !
          <br />
          <Link to="/products" className="underline">
            👉 Voir la liste
          </Link>
        </div>
      )}

      <h1 className="text-2xl font-bold mb-4">{product.articleName}</h1>
      <p className="text-lg text-gray-700 mb-2">Statut : {product.status}</p>
      <p className="text-sm text-gray-500 mb-2">ID : {product.productId}</p>

      {/* 👤 Infos vendeur */}
      <p className="text-sm text-gray-700 mb-4">
        Vendeur : {product.ownerName || "Inconnu"}
        {product.city ? ` — ${product.city}` : ""}
      </p>

      {/* QR CODE */}
      <div className="mb-6">
        <QRCodeCanvas value={getQRUrl(product.productId)} size={150} />
      </div>

      <Link
        to="/products"
        className="mt-2 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
      >
        ⬅️ Retour à la liste des produits
      </Link>

      {/* Historique invité */}
      {ready && (
        <Link
          to="/login"
          className="mt-4 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition"
        >
          📜 Voir mon historique invité
        </Link>
      )}
    </div>
  );
};

export default PublicProductPage;
